import { Link } from '@inertiajs/react';
import React from 'react';

const NavLink = ({ active, href, children }) => {
  const classes = active
    ? 'inline-flex items-center px-4 my-2 py-3 bg-dark rounded-button text-white text-lg w-full duration-maxi opacity-100'
    : 'inline-flex items-center px-4 my-2 py-3 bg-transparent rounded-button text-white text-lg w-full opacity-70 duration-maxi hover:bg-grey-700 hover:opacity-100';

  return (
    <Link href={href} className={classes}>
      {children}
    </Link>
  );
};

export default NavLink;
